import React, { useState } from "react";
import { Avatar, Box, Button, Menu, MenuItem } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from "react-router-dom";
import {
  userGroup,
  userRow,
  userAvatarBox,
  userNameWrap,
  userNameInner,
  userName,
} from "../styles/BannerStyles";

interface UserMenuProps {
  user: string;
}

const UserMenu: React.FC<UserMenuProps> = ({ user }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [, setUser] = useState<string>(sessionStorage.getItem("userName") || "");
  const navigate = useNavigate();

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("refreshToken");
    sessionStorage.removeItem("storeNumber");
    sessionStorage.removeItem("email");
    localStorage.removeItem("email");
    localStorage.removeItem("userName");
    localStorage.removeItem("storeNumber");
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    const cookies = document.cookie.split("; ");
    for (let c = 0; c < cookies.length; c++) {
        const d = window.location.hostname.split(".");
        while (d.length > 0) {
            const cookieParts = cookies[c]?.split(";")[0]?.split("=");
            const cookieName = cookieParts && cookieParts[0] ? cookieParts[0] : '';
            const cookieBase = encodeURIComponent(cookieName) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
            const p = location.pathname.split('/');
            document.cookie = cookieBase + '/';
            while (p.length > 0) {
                document.cookie = cookieBase + p.join('/');
                p.pop();
            };
            d.shift();
        }
    }
    setUser("");
    navigate("/login");
  };

  return (
    <Box sx={userGroup}>
      {user ? (
        <>
          <Button
            onClick={handleMenuOpen}
            sx={{
              ...userRow,
              minWidth: 0,
              padding: 0,
              textTransform: "none",
              color: "white",
              background: "transparent",
              "&:hover": { background: "rgba(255,255,255,0.08)" },
            }}
          >
            <Avatar sx={userAvatarBox} />
            <Box sx={userNameWrap}>
              <Box sx={userNameInner}>
                <Box sx={userName}>{user}</Box>
              </Box>
            </Box>
            <ExpandMoreIcon sx={{ color: "white" }} />
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </>
      ) : (
        <Button
          onClick={() => navigate("/login")}
          sx={{
            color: "white",
            background: "transparent",
            textTransform: "none",
            "&:hover": { background: "rgba(255,255,255,0.08)" },
          }}
        >
          Login
        </Button>
      )}
    </Box>
  );
};

export default UserMenu;
